module.exports = __webpack_public_path__ + "static/media/assesibility.681cb7e8.svg";